// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:27
import { ProcedureAction_abstract } from './../abstract/SagaActionLib/ProcedureAction_abstract';
export class ProcedureAction extends ProcedureAction_abstract {}
